/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import * as R from 'ramda';
import { useNavigate, useParams } from 'react-router-dom';

import usePersistentFilters from 'hooks/usePersistentFilters';
import Projections from './projections/Projections';
import Reports from './reports/Reports';

const panelStyles = { px: 0, py: { xs: 1, lg: 3 } };

const Dashboard = () => {
  const { view } = useParams();
  const navigate = useNavigate();

  const [filters, setFilters] = usePersistentFilters(
    'inventoryProjections',
    {
      allocationGroup: null,
      productGroup: null,
    },
    {}
  );

  const handleChange = val => {
    navigate(`../${val}`, {
      replace: true,
    });
  };

  return (
    <Box
      sx={{
        mb: 0,
        mt: 9,
        px: { xs: 2, lg: 3 },
      }}
    >
      <TabContext value={view}>
        <Box
          sx={{
            backgroundColor: 'surface.light',
            borderBottom: 1,
            borderColor: 'divider',
            bottom: 0,
            boxShadow: { xs: 1, lg: 'none' },
            left: 0,
            position: { xs: 'fixed', lg: 'relative' },
            mt: { xs: 1, lg: 2 },
            width: 1,
            zIndex: 1,
          }}
        >
          <TabList
            onChange={R.compose(handleChange, R.nthArg(1))}
            sx={{
              '& > div > .MuiTabs-flexContainer': {
                justifyContent: { xs: 'center', lg: 'flex-start' },
              },
            }}
          >
            <Tab label="Inventory Projections" value="projections" />
            <Tab label="Inventory Reports" value="reports" />
          </TabList>
        </Box>
        <TabPanel sx={panelStyles} value="projections">
          <Projections filters={filters} setFilters={setFilters} />
        </TabPanel>
        <TabPanel sx={{ ...panelStyles, pb: { xs: 0, lg: 0 } }} value="reports">
          <Reports />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default Dashboard;
